<template>
  <a-row :gutter="10">
    <a-col :md="leftColMd" :sm="24" style="margin-bottom: 20px">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-row :gutter="24">
                <a-col :md="6" :sm="8">
                  <a-form-item label="数据库地址">
                    <j-input placeholder="请输入数据库地址" v-model.trim="queryParam.databaseAddress"></j-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="8">
                  <a-form-item label="负责人">
                    <j-input placeholder="请输入负责人" v-model.trim="queryParam.responsiblePerson"></j-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="8">
                  <a-form-item label="数据库名称">
                    <j-input placeholder="请输入数据库名称" v-model.trim="queryParam.databaseName"></j-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="8">
                  <a-form-item label="所属业务">
                    <j-input placeholder="请输入所属业务" v-model.trim="queryParam.business"></j-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="8">
                  <a-form-item label="是否备份">
                    <j-dict-select-tag
                      v-model="queryParam.isBackup"
                      placeholder="请选择是否备份"
                      dictCode="backup_or_not"
                    ></j-dict-select-tag>
                  </a-form-item>
                </a-col>
                <span style="float: right; overflow: hidden" class="table-page-search-submitButtons">
              <a-col :md="6" :sm="24">
                <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? '收起' : '展开' }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                </a>
              </a-col>
            </span>
              </a-row>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="batchDel">
                <a-icon type="delete"/>
                删除
              </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px"> 批量操作
              <a-icon type="down"/>
            </a-button>
          </a-dropdown>
        </div>

        <!-- table区域-begin -->
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a
            style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
            <a style="margin-left: 24px" @click="onClearSelected">清空</a>
          </div>

          <a-table
            ref="table"
            size="middle"
            bordered
            :scroll="{ x: true }"
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio'}"

            @change="handleTableChange">

            <template slot="htmlSlot" slot-scope="text">
              <div v-html="text"></div>
            </template>
            <template slot="imgSlot" slot-scope="text">
              <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
              <img v-else :src="getImgView(text)" height="25px" alt="图片不存在"
                   style="max-width:80px;font-size: 12px;font-style: italic;"/>
            </template>
            <template slot="fileSlot" slot-scope="text">
              <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
              <a-button
                v-else
                :ghost="true"
                type="primary"
                icon="download"
                size="small"
                @click="uploadFile(text)">
                下载
              </a-button>
            </template>

            <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a @click="handleOpen(record)">角色</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="确定修改为主配置吗?" :disabled="record.master" @confirm="() => handleMaster(record.id)">
            <a :disabled="record.master">主配置</a>
          </a-popconfirm>
          <a-divider type="vertical"/>
          <a @click="handleTest(record.id)">测试</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a style="color: #f56c6c;">删除</a>
          </a-popconfirm>

              <!--          <a-divider type="vertical" />
                        <a-dropdown>
                          <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                          <a-menu slot="overlay">
                            <a-menu-item>
                              <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                                <a>删除</a>
                              </a-popconfirm>
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>-->
        </span>

          </a-table>
        </div>

        <FileConfigModal ref="modalForm" @ok="modalFormOk"></FileConfigModal>
      </a-card>
    </a-col>
    <a-col :md="rightColMd" :sm="24" v-if="this.rightcolval == 1">
      <FileConfigRoleList ref="fileConfigRoleList"></FileConfigRoleList>
    </a-col>
  </a-row>

</template>

<script>

import {JeecgListMixin} from '@/mixins/JeecgListMixin'
import FileConfigModal from './modules/FileConfigModal'
import JInput from "@comp/jeecg/JInput";
import {putAction, getAction} from '@/api/manage'
import FileConfigRoleList from '../fileconfigrole/FileConfigRoleList.vue'


export default {
  name: "FileConfigList",
  mixins: [JeecgListMixin],
  components: {
    JInput,
    FileConfigModal,
    FileConfigRoleList
  },
  data() {
    return {
      description: '附件配置页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '配置名',
          align: "center",
          dataIndex: 'name'
        },
        {
          title: '存储器',
          align: "center",
          dataIndex: 'storage_dictText'
        },
        {
          title: '是否主配置',
          align: "center",
          dataIndex: 'master',
          customRender: function (t, r, index) {
            return t ? '是' : '否';
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'}
        }
      ],
      url: {
        list: "/file.base/file-config/page",
        // list: "/assetstorage.base/busAssetStorageDetail/list",
        delete: "/assetstorage.base/busAssetStorageDetail/delete",
        deleteBatch: "/assetstorage.base/busAssetStorageDetail/deleteBatch",
        exportXlsUrl: "/assetstorage.base/busAssetStorageDetail/exportXls",
        importExcelUrl: "assetstorage.base/busAssetStorageDetail/importExcel",
        updateMaster: "/file.base/file-config/update-master?id=",
        test: "/file.base/file-config/test?id="
      },
      rightcolval: 0,
      dictOptions: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
    leftColMd() {
      return this.selectedRowKeys.length === 0 ? 24 : 12
    },
    rightColMd() {
      return this.selectedRowKeys.length === 0 ? 0 : 12
    },
  },
  methods: {
    initDictConfig() {
    },
    handleMaster(id) {
      putAction(this.url.updateMaster + id, {}).then(res => {
        if (res.success) {
          this.$message.success("修改成功")
          this.loadData()
        } else {
          this.$message.error("修改失败")
        }
      })
    },
    handleOpen: function (record) {
      this.selectedRowKeys = [record.id]
      this.selectionRows = [record]
      this.rightcolval = 1
      this.$nextTick(() => {
        this.$refs.fileConfigRoleList.init(this.selectionRows[0])
      })
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
      this.rightcolval = 1
      this.$nextTick(() => {
        this.$refs.fileConfigRoleList.init(this.selectionRows[0])
      })
    },
    handleTest(id) {
      getAction(this.url.test + id, {}).then(res => {
        if (res.success) {
          this.$message.success("测试通过，上传文件成功！访问地址：" + res.message)
        } else {
          this.$message.error("测试失败")
        }
      })
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>